import { css, createGlobalStyle } from 'styled-components';
import React from 'react';
import theme from 'lib/theme';
import color from 'color';

//${ props => props.theme.color.gray }

const getSolid = ($color: string) => {
  var $dark = color($color).darken(0.1).hex();

  return css`
    color: #fff;
    background-color: ${$color};
    border-color: ${$color};
    &:hover {
      color: #fff;
      background-color: ${$dark};
      border-color: ${$dark};
    }
  `;
};
const getOutline = ($color: string, $fontColor: string = $color) => {
  return css`
    background-image: none;
    background-color: transparent;
    color: ${$fontColor}!important;
    border-color: ${$color};
    &:hover {
      color: #fff !important;
      background-color: ${$color};
      border-color: ${$color};
    }
  `;
};

const Btn = createGlobalStyle`
.btn-default,
.btn-primary,
.btn-disable,
.btn-success,
.btn-second,
.btn-info,
.btn-warn,
.btn-solid-default,
.btn-solid-primary,
.btn-solid-disable,
.btn-solid-success,
.btn-solid-info,
.btn-solid-warn,
.btn {
  display: inline-block;
  font-style:normal;
  font-weight: normal;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: 1px solid transparent;

  padding:7px 1em;
  font-size:14px;
  border-radius:2px;

  transition:all .2s ease-in-out;
  text-decoration: none;

  //&:active,
  //&.active {
  //  background-image: none;
  //  outline: 0;
  //  box-shadow:$btn-active-box-shadow;
  //}

  //&:hover{
  //  opacity: .8;
  //}

  &.disabled,
  &:disabled {
    cursor: not-allowed;
    opacity: .6;
    box-shadow:none;
  }

}


.btn-primary,
.btn-solid-primary {
  ${getSolid(theme.color.primary)}
}
.btn-outline-primary {
   ${getOutline(theme.color.primary)}
}


.btn-second,
.btn-solid-second {
  ${getSolid(theme.color.second)}
}
.btn-outline-second {
   ${getOutline(theme.color.second)}
}
.btn-white-text{
  color:#fff!important;
}

.btn-default,
.btn-solid-default,
.btn-secondary,
.btn-solid-secondary {
  ${getSolid(theme.color.secondary)}
}
.btn-outline-default,
.btn-outline-secondary {
  ${getOutline('#D8D8D8', theme.color.default)}
}

.btn-info,
.btn-solid-info {
  ${getSolid(theme.color.info)}
}
.btn-outline-info {
  ${getOutline(theme.color.info)}
}

.btn-success,
.btn-solid-success {
  ${getSolid(theme.color.primary)}
}
.btn-outline-success {
  ${getOutline(theme.color.primary)}
}

.btn-dark,
.btn-solid-dark {
  ${getSolid(theme.color.dark)}
}
.btn-outline-dark {
  ${getOutline(theme.color.dark)}
}

.btn-white,
.btn-solid-white {
  ${getSolid(theme.color.white)}
  color:${theme.color.dark};
  &:hover{
  color:${theme.color.dark};
  }
}
.btn-outline-white {
  ${getOutline(theme.color.white)}

  &:hover{
  color:${theme.color.second}!important;
  border-color:${theme.color.second}!important;
  background-color:transparent;
  }
}


.uploadifive-button {
  padding: 0;
}


.btn-plain-red,
.btn-danger,
.btn-solid-danger,
.btn-red,
.btn-solid-red,
.btn-warn,
.btn-solid-warn {
  ${getSolid(theme.color.second)}
}

.btn-outline-danger,
.btn-outline-red,
.btn-outline-warn {
  ${getOutline(theme.color.warn)}
}




.btn-disable,
.btn-solid-disable {
  ${getSolid(theme.color.grayLighter)};
  cursor:not-allowed;
}
.btn-outline-disable {
  ${getOutline(theme.color.grayLighter)};
  cursor:not-allowed;
}


.btn-link {
  font-weight: normal;
  border-radius: 0;

  &:hover,
  &:active,
  &.active {
    background-color: transparent;
    border-color:transparent;
    box-shadow:none;
  }
}



.btn-lg{
  padding:9px 1.5em;
  font-size:16px;
  border-radius:4px;
}
.btn-sm{
  padding:3px .5em;
  font-size:10px;
}
.btn-xs{
  padding:2px .2em;
  font-size:10px;
}
.btn-round{
  border-radius: 100px;
}
.btn-block {
  display: block;
  width:100%;
  padding-right:0;
  padding-left:0;
}
.btn-block + .btn-block {
  margin-top: .5em;
}

input[type="submit"],
input[type="reset"],
input[type="button"] {
  &.btn-block {
    width: 100%;
  }
}
`;

export default Btn;
